import { ReactNode, createContext, useContext, useState } from 'react';
import { JobListDefn } from '../index';

type JobListContextType = {
    jobList: JobListDefn;
    setJobList: (jobList: JobListDefn) => void;
    onJobCardClicked: (jobId: string) => void;
    setOnJobCardClickHandler: (
        onJobCardClicked: (jobId: string) => void
    ) => void;
    totalJobs: number;
    setTotalJobs: (totalJobs: number) => void;
    hasMoreJobs: boolean;
    setHasMoreJobs: (hasMoreJobs: boolean) => void;
    fetchNextPage: (() => void) | undefined;
    setFetchNextPage: (fetchNextPage: (() => void) | undefined) => void;
    isLoading: boolean;
    setIsLoading: (isLoading: boolean) => void;
};

const JobListContext = createContext<JobListContextType | undefined>(undefined);
export const JobListProvider = ({
    children,
}: {
    children: ReactNode;
}): JSX.Element => {
    const [jobList, setJobList] = useState<JobListDefn>([]);
    const [onJobCardClicked, setOnJobCardClickHandlerState] = useState<
        (jobId: string) => void
    >(() => void 0);
    const [totalJobs, setTotalJobs] = useState<number>(0);
    const [hasMoreJobs, setHasMoreJobs] = useState<boolean>(false);
    const [fetchNextPage, setFetchNextPageState] = useState<
        (() => void) | undefined
    >(undefined);
    const [isLoading, setIsLoading] = useState<boolean>(false);

    return (
        <JobListContext.Provider
            value={{
                jobList,
                setJobList,
                onJobCardClicked,
                setOnJobCardClickHandler: (onJobCardClicked) =>
                    setOnJobCardClickHandlerState(() => onJobCardClicked),
                totalJobs,
                setTotalJobs,
                hasMoreJobs,
                setHasMoreJobs,
                fetchNextPage,
                setFetchNextPage: (fetchNextPage) =>
                    setFetchNextPageState(() => fetchNextPage),
                isLoading,
                setIsLoading,
            }}
        >
            {children}
        </JobListContext.Provider>
    );
};

export const useJobList = () => {
    const context = useContext(JobListContext);
    if (context === undefined) {
        throw new Error('useJobList must be used within a JobListProvider');
    }
    return context;
};
